import  img1 from "../src/img/myhop.png";
import img2 from "../src/img/admin-dashboard.png";
import img3 from "../src/img/vps.png";
import img4 from "../src/img/college-space.png";
export const products=[
    {
        id:1,
        img:img3,
        link:"https://github.com/pank1999/virtual-police-station"
    },
    {
        id:2,
        img:img1,
        link:"https://github.com/pank1999/Myshop-E-commerce-app"
    },
    {
        id:3,
        img:img4,
        link:"https://github.com/pank1999/College-Space"
    },
     {
        id:4,
        img:"https://mobirise.com/assets52/images/features1.jpg",
        link:"https://github.com/pank1999"
    },
    {
        id:5,
        img:"https://img.freepik.com/free-psd/website-instant-showcase-mockup-isolated_359791-227.jpg?w=2000",
        link:"https://github.com/pank1999"
    },
    {
        id:6,
        img:"https://mobirise.com/assets52/images/features1.jpg",
        link:"https://github.com/pank1999"
    }
]